import React from "react";
import seatcapacity from "../../../assets/images/seat-capacity.png";
import enginetype from "../../../assets/images/engine-type.png";
import carfeatures from "../../../assets/images/car-feature.png";
import fueltype from "../../../assets/images/fuel-type.png";


const mainFeature = () => {
  return (
    <section className="main-features-wrap">
      {" "}

     

    
        <div className="5-seats">
          <div className="icon-wrap">
          <span>
            <img className="icon" src={seatcapacity} alt="seat-capacity" /></span>
            <div className="feature-text">5 seats</div>
          </div>
        </div>
        <div className="icon-wrap">
        <span>
          <img className="icon" src={carfeatures} alt="engine-type" /></span>
          <div className="feature-text">AC</div>
        </div>
        <div className="icon-wrap">
        <span>
          <img className="icon" src={enginetype} alt="car-feature" /></span>
          <div className="feature-text">Manual</div>
        </div>
        <div className="icon-wrap">
        <span>
          <img className="icon" src={fueltype} alt="fuel-type" /></span>
          <div className="feature-text">Diesal</div>
        </div>
   
    </section>
  );
};

export default mainFeature;
